import React, { useState, useEffect } from 'react';
import { fetchDataSourceTimestamps, dispatchWorkflow } from '../services/api';

const WorkflowButtons = ({ onError }) => {
  const [correctionsLoading, setCorrectionsLoading] = useState(false);
  const [scoutDataLoading, setScoutDataLoading] = useState(false);
  const [timestamps, setTimestamps] = useState(null);
  const [timestampsLoading, setTimestampsLoading] = useState(false);

  const loadTimestamps = async () => {
    setTimestampsLoading(true);
    try {
      const data = await fetchDataSourceTimestamps();
      setTimestamps(data);
    } catch (error) {
      console.error('Error fetching timestamps:', error);
      onError?.(error.message);
    } finally {
      setTimestampsLoading(false);
    }
  };

  useEffect(() => {
    loadTimestamps();
  }, []);

  const triggerWorkflow = async (workflowFile, setLoading, workflowName) => {
    setLoading(true);
    try {
      await dispatchWorkflow(workflowFile, workflowName);
      alert(`${workflowName} workflow triggered successfully!`);
    } catch (error) {
      console.error(`Error triggering ${workflowName}:`, error);
      onError?.(error.message);
    } finally {
      setLoading(false);
    }
  };

  const handleUpdateCorrections = () => {
    triggerWorkflow('update_corrections.yml', setCorrectionsLoading, 'Update Corrections');
  };

  const handleUpdateScoutData = () => {
    triggerWorkflow('update_scout_data.yml', setScoutDataLoading, 'Update Scout Data');
  };

  const handleRefreshTimestamps = () => {
    loadTimestamps();
  };

  // Set for which files we want to show the timestamps
  const allowedKeys = ['base-rate-model/Corrections.xlsx', 'base-rate-model/Materials.xlsx',
      'base-rate-model/Scout_data.xlsx', 'base-rate-model/Historical_data.xlsx'];

  return (
    <div className="workflow-buttons">
      <h3>Data Management</h3>
      <p>The corrections and scout data are updated automatically every evening on work days.</p>
      <p>However, if you need to update them manually, you can do so by clicking the buttons below.</p>

      <div className="timestamps-section">
        <h4>Data Source Timestamps</h4>
        {timestampsLoading && <p>Loading data source timestamps...</p>}
        {!timestampsLoading && timestamps && (
          <table style={{ width: '100%', textAlign: 'left' }}>
            <thead>
              <tr>
                <th>Data Source</th>
                <th>Timestamp</th>
              </tr>
            </thead>
            <tbody>
              {Object.entries(timestamps)
                .filter(([key]) => allowedKeys.includes(key)) // Filter entries based on allowed keys
                .map(([key, lastModified]) => (
                  <tr key={key}>
                    <td>{key}</td>
                    <td>{lastModified ? new Date(lastModified).toLocaleString() : 'Unknown'}</td>
                  </tr>
                ))}
            </tbody>
          </table>
        )}
      </div>

      <div className="button-group">
        <button
          onClick={handleUpdateCorrections}
          disabled={correctionsLoading || scoutDataLoading}
          className="workflow-button update-button"
        >
          {correctionsLoading ? 'Updating...' : 'Update Corrections'}
        </button>

        <button
          onClick={handleUpdateScoutData}
          disabled={correctionsLoading || scoutDataLoading}
          className="workflow-button update-button"
        >
          {scoutDataLoading ? 'Updating...' : 'Update Scout Data'}
        </button>

        <button
          onClick={handleRefreshTimestamps}
          className="workflow-button update-button"
        >
          {timestampsLoading ? 'Refreshing...' : 'Refresh Timestamps'}
        </button>
      </div>
    </div>
  );
};

export default WorkflowButtons;